import { isReturnStatement } from "typescript";
import { Get, Put } from "../server";
import axios from "axios";

export function getUserCount() {
  //Get方法用于向后台发送请求
  return Get("/admin/dataCenter/userCount");
}

export function getGroupCount() {
  //Get方法用于向后台发送请求
  return Get("/admin/dataCenter/groupCount");
}

export function getNewAddUser(params: any) {
  //Get方法用于向后台发送请求
  return Get(`/admin/dataCenter/newUserCount`, params);
}

export function getNewAddGroup(params: any) {
  //Get方法用于向后台发送请求
  return Get(`/admin/dataCenter/newGroupCount`, params);
}

export function getNewAddRecord(params: any) {
  //Get方法用于向后台发送请求
  return Get(`/admin/dataCenter/onlineCount`, params);
}


export function getRedEnvelopeAmount() {
  return Get(`/admin/dataCenter/redEnvelopeAmount`)
}

export function getTransferMoneyAmount() {
  return Get(`/admin/dataCenter/transferMoneyAmount`)
}

export function goldAmount() {
  return Get(`/admin/dataCenter/goldAmount`)
}

export function silverAmount() {
  return Get(`/admin/dataCenter/silverAmount`)
}

export function homeCount() {
  return Get('/admin/dataCenter/home')
}

export function homeStatistics(params: any) {
  return Get('/admin/dataCenter/statistics', params)
}

// 获取斜线图数据
export function Getstatistics(params: any) {
  return Get('/admin/dataCenter/statistics', params)
}

// 获取统计数据
export function GetdataCenter() {
  return Get('/admin/dataCenter/home')
}

// 设置首页配置接口
export function Getcontent() {
  return Get('/admin/user/index/content')
}

// 设置首页配置接口
export function submitcontent(data: any) {
  // return Put('/admin/user/index/content')
  return axios({
    url: `/admin/user/index/content`,
    method: "put",
    headers: {
      "Content-Type": "	application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}